import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignUpMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
  username: Types.Scalars['String']['input'];
  newsletter: Types.Scalars['Boolean']['input'];
  registerCode?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signup: { __typename?: 'Auth', accessToken: string, refreshToken: string, mediaToken: string, user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, role: string, visibility: Types.UserVisibility } } };


export const SignUpDocument = gql`
    mutation SignUp($email: String!, $password: String!, $username: String!, $newsletter: Boolean!, $registerCode: String) {
  signup(
    data: {email: $email, password: $password, username: $username, newsletter: $newsletter, registerCode: $registerCode}
  ) {
    accessToken
    refreshToken
    mediaToken
    user {
      id
      uuid
      email
      username
      photoUrl
      role
      visibility
    }
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      username: // value for 'username'
 *      newsletter: // value for 'newsletter'
 *      registerCode: // value for 'registerCode'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;